<template>
  <div class="expense-modal-summary__totals">
    <div>
      <span>{{ resolvedText.subtotal }}</span>
      <strong>{{ formatMoney(taxPreview.subtotal) }}</strong>
    </div>

    <div v-if="showTaxBreakdownSummary">
      <span>{{ resolvedText.transferred }}</span>
      <strong>{{ formatMoney(taxPreview?.taxes?.transferred_total) }}</strong>
      <div
        v-if="showTaxSectionBreakdown && transferredTaxItems.length > 0"
        class="expense-tax-breakdown-total"
      >
        <span class="expense-tax-breakdown-total__line"></span>
      </div>
      <div
        v-if="showTaxSectionBreakdown && transferredTaxItems.length > 0"
        class="expense-modal-summary__breakdown"
      >
        <div
          v-for="(item, index) in transferredTaxItems"
          :key="`tax-transferred-${index}-${item.id || 0}-${item.name || ''}`"
          class="expense-tax-breakdown-item"
        >
          <small>{{ formatTaxBreakdownLine(item) }}</small>
        </div>
      </div>
    </div>

    <div v-if="showTaxBreakdownSummary">
      <span>{{ resolvedText.withheld }}</span>
      <strong>{{ formatMoney(taxPreview?.taxes?.withheld_total) }}</strong>
      <div
        v-if="showTaxSectionBreakdown && withheldTaxItems.length > 0"
        class="expense-tax-breakdown-total"
      >
        <span class="expense-tax-breakdown-total__line"></span>
      </div>
      <div
        v-if="showTaxSectionBreakdown && withheldTaxItems.length > 0"
        class="expense-modal-summary__breakdown"
      >
        <div
          v-for="(item, index) in withheldTaxItems"
          :key="`tax-withheld-${index}-${item.id || 0}-${item.name || ''}`"
          class="expense-tax-breakdown-item"
        >
          <small>{{ formatTaxBreakdownLine(item) }}</small>
        </div>
      </div>
    </div>

    <div>
      <span>{{ resolvedText.total }}</span>
      <strong>{{ formatMoney(taxPreview.total) }}</strong>
    </div>
  </div>
</template>

<script>
const defaultText = {
  subtotal: 'Subtotal',
  transferred: 'Trasladados',
  withheld: 'Retenciones',
  total: 'Total',
};

export default {
  name: 'AppGeneralTotalsSummary',
  props: {
    taxPreview: {
      type: Object,
      required: true,
    },
    text: {
      type: Object,
      default: () => ({}),
    },
    showTaxBreakdownSummary: {
      type: Boolean,
      default: false,
    },
    showTaxSectionBreakdown: {
      type: Boolean,
      default: false,
    },
    transferredTaxItems: {
      type: Array,
      default: () => [],
    },
    withheldTaxItems: {
      type: Array,
      default: () => [],
    },
    formatMoney: {
      type: Function,
      required: true,
    },
    formatTaxBreakdownLine: {
      type: Function,
      required: true,
    },
  },
  computed: {
    resolvedText() {
      const source = this.text && typeof this.text === 'object' ? this.text : {};
      return {
        ...defaultText,
        ...source,
      };
    },
  },
};
</script>
